// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"536":"90bfbc24","787":"b77455df","932":"aafa96e3","954":"6be255fe"}[chunkId] + ".chunk.js";
};